import {Button} from '@kit';

import React from 'react';

import {Link} from '../../lib/routes';
import {useCookieConsent} from './use-cookie-consent';

import css from './cookie-banner.module.css';

export const CookieBanner: React.FC = () => {
	const {notice, dismiss} = useCookieConsent();

	if (notice !== 'none') return null;

	return (
		<div className={css.banner} role="region" aria-label="Использование cookie">
			<p className={css.text}>
				Сайт использует cookie и Яндекс.Метрику, чтобы понимать, как посетители пользуются справочником.
				Продолжая пользоваться сайтом, вы соглашаетесь с этим. Подробнее — в{' '}
				<Link route="privacy" keepQuery={false}>
					политике конфиденциальности
				</Link>
				.
			</p>
			<div className={css.buttons}>
				<Button appearance="primary" onClick={dismiss}>
					Понятно
				</Button>
			</div>
		</div>
	);
};
